import {useCallback} from 'react';

import {useReadOnlyDataHook} from 'src/hooks/use-read-only-data-hook';
import {getLcdSubscriptionsTrees} from 'src/openapi/admin/apis/LcdSubscriptionsDictionaryApi';
import {useAppDispatch} from 'src/store/hooks';

export const useLcdSubscriptionTrees = () => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback((signal: AbortSignal) => apiDispatch(
        getLcdSubscriptionsTrees({signal}),
    ), [apiDispatch]);

    return useReadOnlyDataHook({
        initValue: [],
        getDispatchAction,
    });
};
